import { autoinject } from "aurelia-framework";
import URL from "url-parse";

@autoinject()
export class OriginService {

    private readonly originNameKey = "originName";
    private readonly originUrlKey = "originUrl";

    public get name() {
        return this.getItem(this.originNameKey);
    }

    public set name(name: string) {
        this.setItem(this.originNameKey, name);
    }

    public get url() {
        return this.getItem(this.originUrlKey);
    }

    public set url(url: string) {
        if (URL(url).hostname.endsWith(".axxessweb.com") || URL(url).hostname.endsWith(".axxess.tech")) {
            this.setItem(this.originUrlKey, url);
        }
    }

    public clear() {
        this.removeItem(this.originNameKey);
        this.removeItem(this.originUrlKey);
    }

    private removeItem(key: string) {
        window.sessionStorage.removeItem(key);
    }

    private setItem(key: string, value: string) {
        window.sessionStorage.setItem(key, value);
    }

    private getItem(key: string) {
        return window.sessionStorage.getItem(key);
    }
}